import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { SimpleResponse } from 'Types/simpleResponse'
import { RequestParams, ResponseCatalog } from 'Models'
import { SurveyModel, ResultsFilters, FileModel } from 'Pages/survey'
import { FileWithPreview } from 'LibNeo'

export const surveyApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<SurveyModel>>(urls.survey.base, { params })
		return res.data
	},
	getOne: async (id: number) => {
		const res = await axiosDS().get<SurveyModel>(`${urls.survey.base}/${id}`)
		return res.data
	},
	createOne: async (data: SurveyModel) => {
		const res = await axiosDS().post<SurveyModel>(urls.survey.base, { data })
		return res.data
	},
	updateOne: async (id: number, data: SurveyModel) => {
		const res = await axiosDS().patch<SurveyModel>(`${urls.survey.base}/${id}`, { data })
		return res.data
	},
	deleteOne: async (id: number) => {
		const res = await axiosDS().delete(`${urls.survey.base}/${id}`)
		return res.data
	},
	downloadSurveyResults: async (id: number, params: ResultsFilters) => {
		const res = await axiosDS().get(
			`${urls.survey.download_results}/survey_results_full?survey_id=${id}`,
			{ params }
		)
		return res.data
	},
	showSurveyResults: async (id: number, params: ResultsFilters) => {
		const res = await axiosDS().get<{ results: unknown }>(`${urls.survey.base}/${id}/result`, {
			params,
		})
		return res.data
	},
	loadSurveyDocument: async (params: { id: number; file: FileWithPreview | FileWithPreview[] }) => {
		const data = new FormData()
		// @ts-ignore
		data.append('[data][file]', params.file)
		const res = await axiosDS().post<FileModel>(`${urls.survey.base}/${params.id}/attachment`, data)
		return res.data
	},
	deleteSurveyFile: async (file: string) => {
		const res = await axiosDS().delete<SimpleResponse>(`/exam/${file}`)
		return res.data
	},
}
